/**
 * Billing API
 * Mock checkout + plan/usage reads. Reuses the shared authed apiClient so every
 * request carries the Clerk session token (same pattern as the other api/*).
 */

import { apiClient } from './client';

export interface PlanResponse {
  plan: string;
  unlimited: boolean;
  limits: Record<string, number>;
}

export interface CheckoutResponse {
  ok: boolean;
  plan: string;
  mock: boolean;
}

export const billingAPI = {
  postMockCheckout: (plan: string) =>
    apiClient.post<CheckoutResponse>('/checkout/mock', { plan }),
  getMyPlan: () => apiClient.get<PlanResponse>('/me/plan'),
  getMyUsage: () => apiClient.get<Record<string, unknown>>('/me/usage'),
};
